module.exports = __webpack_public_path__ + "static/img/traffic_date.8000d414.svg";